const se = typeof Symbol !== 'undefined'
const ste = se && typeof Symbol.toStringTag !== 'undefined'

export function getTypeOf (obj: any): string {
  const typeofObj = typeof obj
  if (typeofObj !== 'object') {
    return typeofObj
  }
  if (obj === null) {
    return 'null'
  }

  if (Array.isArray(obj) && (!ste || !(Symbol.toStringTag in obj))) {
    return 'Array'
  }

  let stringTag: string | undefined
  if (ste) {
    try {
      stringTag = obj[Symbol.toStringTag]
    } catch {
      stringTag = undefined
    }
  }
  if (typeof stringTag === 'string') {
    return stringTag
  }

  const objPrototype = Object.getPrototypeOf(obj)

  if (objPrototype === RegExp.prototype) {
    return 'RegExp'
  }
  if (objPrototype === Date.prototype) {
    return 'Date'
  }

  if (objPrototype === null) {
    return 'Object'
  }
  try {
    return {}.toString.call(obj).slice(8, -1)
  } catch {
    return 'Object'
  }
}

export function clone (
  obj: any,
  as?: (doc: any, m: any) => any,
  needAs?: (value: any) => any | undefined,
  depth?: number
): any {
  if (typeof obj === 'undefined') {
    return undefined
  }
  if (typeof obj === 'function') {
    return obj
  }
  if (depth === 0) {
    return obj
  }
  depth = depth === undefined ? depth : depth - 1
  const typeOf = getTypeOf(obj)
  if (typeOf === 'Date') {
    return new Date(obj.getTime())
  } else if (typeOf === 'Array' || typeOf === 'Object') {
    const isArray = Array.isArray(obj)
    const result: any = isArray ? [] : { ...obj }
    for (const key in obj) {
      // include prototype properties
      const value = obj[key]
      const type = getTypeOf(value)
      if (type === 'Array') {
        result[key] = clone(value, as, needAs, depth)
      } else if (type === 'Object') {
        const valClone = clone(value, as, needAs, depth)
        result[key] = valClone
      } else if (type === 'Date') {
        result[key] = new Date(value.getTime())
      } else if (isArray) {
        result[key] = value
      }
    }
    if (typeOf === 'Object') {
      const m = needAs?.(obj)
      return m !== undefined && as !== undefined ? as(result, m) : result
    }
    return result
  } else {
    return obj
  }
}
